import ApiBase from 'Services/Api/ApiBase';

class Documents extends ApiBase {
    route = '/admin/human-resources/:user/documents';
};

export default new Documents();